import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import customDetails from './components/customDetails.vue';
import uploadCom from "./components/uploadCom";
import addCom from './components/addCom';
import config from '@/config/index';
import { protocol_list, get_type as _get_type, set_default as _set_default, protocol_add, dict_update, protocol_del, daoru as _daoru, daochu, get_downloadtoken } from '@/api/jingxiaoshang';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      product_type_codeData: [],
      country_codeData: [{
        "value": "xciot-prod-cnsz",
        "name": "中国区"
      }, {
        "value": "xciot-prod-hk",
        "name": "香港区"
      }, {
        "value": "xciot-prod-eu",
        "name": "欧洲区"
      }, {
        "value": "xciot-prod-us2",
        "name": "美国区"
      }],
      country_code2Data: [{
        "value": "86",
        "name": "中国"
      }],
      form_filter: {
        product_type_code: "",
        xieyi_name: ""
      },
      //共用的查询与重置
      topButtonList: [{
        name: this.$t("query"),
        type: 'primary',
        method: this.search
      }, {
        name: this.$t("reset"),
        type: 'error',
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [// {
        //   name:this.$t('refresh'),
        //   icon:'ios-refresh',
        //   type:'primary',
        //   method:this.init
        // }
      ],
      reqBase: {
        page: 1,
        page_size: 15
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: this.$t('edit'),
        type: 'primary',
        icon: '',
        method: this.edit
      }, {
        name: this.$t('delete'),
        type: 'primary',
        icon: '',
        method: this.del
      }, {
        name: this.$t('details'),
        type: 'primary',
        icon: '',
        method: this.details
      }],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [// {
      //   align: 'center',
      //   title: '产品型号',
      //   minWidth:120,
      //   key: 'model_code',
      // },
      // {
      //   align: 'center',
      //   title: '序号',
      //   key: 'id',
      // },
      {
        align: 'center',
        title: this.$t('协议列表名称'),
        key: 'xieyi_name'
      }, {
        align: 'center',
        title: this.$t('产品名称'),
        key: 'product_name'
      }, {
        align: 'center',
        title: this.$t('dictmenu.creationtime'),
        minWidth: 120,
        key: 'addtime'
      }, {
        align: 'center',
        title: this.$t('operation'),
        minWidth: 150,
        key: 'Operating',
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = []; //this.operationButtonList = [];

          var list = _this2.operationButtonList[0]; //查看

          list = _this2.operationButtonList[2];
          arr.push(h('Button', {
            style: {
              marginLeft: '5px',
              marginBottom: '3px'
            },
            props: {
              type: list.type,
              size: list.size ? list.size : 'small'
            },
            on: {
              click: function click() {
                _this2.details(row);
              }
            }
          }, list.name)); //删除

          list = _this2.operationButtonList[1];
          arr.push(h('Button', {
            style: {
              marginLeft: '5px',
              marginBottom: '3px'
            },
            props: {
              type: list.type,
              size: list.size ? list.size : 'small'
            },
            on: {
              click: function click() {
                _this2.del(row);
              }
            }
          }, list.name));
          return h('div', {
            style: {
              padding: '5px'
            }
          }, arr); // return h('div',arr)
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    get_type: function get_type() {
      var _this3 = this;

      _get_type({}).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          var _msg = res.errorMsg;
          _this3.product_type_codeData = res.body.product_type; //console.log("111",this.protocol_typeData)
          //this.inverter_typeData=res.body.inverter_type
        } else {
          vm.$Message.error(msg);
          _this.buttonLoading = false;
        }
      });
    },

    /**
     * 导入
     */
    daoru: function daoru() {
      var _this4 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h('div', [h('h3', _this4.$t('import')), h(uploadCom, {
            ref: 'uploadCom',
            props: {
              edit: false,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.uploadCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var formData = new FormData();
              formData.append('filename', formModel.filename);

              _daoru(formData).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    daochu: function daochu() {
      var vm = this;
      var config = {
        title: this.$t('export'),
        loading: true,
        content: this.$t('dictmenu.sureexport'),
        onOk: function onOk() {
          var _this = this; // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {


          get_downloadtoken().then(function (res) {
            // console.log(res.result) 
            //     return
            _this.buttonLoading = false;

            if (res.result === 0) {
              var downloadtoken = res.body.downloadtoken;
              var params = "?type=1&downloadtoken=" + downloadtoken;
              window.open("http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" + params);
              vm.$Modal.remove();
            } else {
              vm.$Message.error(res.errorMsg);
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
        * 删除
        */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t('delete'),
        content: this.$t('你确定要删除') + row.xieyi_name + "？",
        loading: true,
        onOk: function onOk() {
          var _this = this;

          protocol_del({
            xieyi_code: row.xieyi_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg2 = res.errorMsg;
              vm.$Message.success(_msg2);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    details: function details(row) {
      var routeData = this.$router.push({
        path: '/protocolman/projectprotocollist2',
        query: _defineProperty({
          xieyi_code: row.xieyi_code,
          product_code: row.product_code,
          project_code: this.$route.query.project_code
        }, "product_code", this.$route.query.product_code)
      });
      window.open(routeData.href, '_self');
    },
    add: function add() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '新增协议列表'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: '0',
              parent_name: '无',
              product_type_codeData: vm.product_type_codeData
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              protocol_add(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg3 = res.errorMsg;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var _this5 = this;

      console.log('a', row);
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this5.$t('dictmenu.editiverterdict')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              edit: true,
              $store: vm.$store,
              _vm: vm,
              setData: row,
              product_type_codeData: vm.product_type_codeData
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //let { area_name, desc, area_code } = obj.formModel
              dict_update(obj.formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg4 = res.errorMsg;
                  vm.$Message.success(_msg4);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    set_default: function set_default(row) {
      // console.log(row)
      var vm = this;
      this.$Modal.confirm({
        title: '设为默认',
        content: '您确定要设置' + row.protocol_name + '为默认吗？',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          _set_default({
            dict_code: row.dict_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg5 = res.errorMsg;
              vm.$Message.success(_msg5);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    init: function init() {
      var _this6 = this;

      this.get_type();
      this.tableLoading = true;
      protocol_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this6.tableLoading = false;
        _this6.tableDataList = [];

        if (res.result === 0) {
          _this6.tableDataList = res.body.list || [];
          _this6.getPageTotal = res.body.total;
        } else {
          _this6.tableDataList = [];
          _this6.getPageTotal = 0;

          _this6.$Message.error(res.errorMsg);
        }
      });
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        product_type_code: null,
        xieyi_name: null
      };
      this.search();
    }
  },
  mounted: function mounted() {
    this.$set(this.reqBase, 'xieyi_code', this.$route.query.xieyi_code);

    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.init();
    }
  },
  created: function created() {// this.getPageSizeToStorage();
  }
};